import _ from 'lodash';
class AssignmentConfirmationController{
  constructor($state, entitlerService, statusIndicatorService) {
    this.name = 'assignmentConfirmation';
    this.$state = $state;
    this.entitlerService = entitlerService;
    this.currentTab = this.$state.params.tabName;
    this.recommendationName = 'Assign';
    this.workflowIsInProgress = false;
    this.batchIsInProgress = false;
    this.statusIndicatorService = statusIndicatorService;
  }

  seatsAvailable(selectedProduct) {
    let seatsAvailable = 'xx';

    if (selectedProduct.seatsAssigned) {
      seatsAvailable = selectedProduct.seatsPurchased - selectedProduct.seatsAssigned;
    }

    return seatsAvailable;
  }

  removeRecommendationFromSelectionList() {
    this.entitler.selectedProducts.length = 1;
  }

  newAssignments() {
    this.resetEntitler();
    this.$state.go('home.assign.productsSelector');
  }
  goToPrevious () {
    this.almostResetEntitler();
    this.$state.go('home.assign.assignments');
  }

  previous() {
    this.workflowIsInProgress = false;
    this.batchIsInProgress = false;
    this.statusIndicatorService.getStatus().then((response) => {
      const batch = response && response.data && response.data.content;
      const assignProductByBatchWorkflow = _.find(batch && batch.workflowTransitions, (a) => a.job === 'assignProductsByBatch' && a.serviceName === 'sections');
      this.batchIsInProgress = assignProductByBatchWorkflow && assignProductByBatchWorkflow.status === 'IN_PROGRESS';
      if (!this.batchIsInProgress) {
        const selectedProduct = this.entitler && this.entitler.selectedProducts.length && this.entitler.selectedProducts && this.entitler.selectedProducts[0];
        if (selectedProduct) {
          this.entitlerService.lastWorkflowForProductAssignment(selectedProduct.id).then((response) => {
            this.workflowIsInProgress = response && response.data && response.data.isInProcess;
            if (!this.workflowIsInProgress) {
              this.goToPrevious();
            }
          }).catch(() => {
            this.goToPrevious();
          });
        } else {
          this.goToPrevious();
        }
      }
    }).catch(() => {
      this.goToPrevious();
    });
  }

  findProductRecommendation() {
    let product = this.entitler.selectedProducts[0];
    if (product && product.edition) {
      this.entitlerService.recommendProductEdition(product).then(this.setRecommendedProduct.bind(this));
    }
  }

  setRecommendedProduct(response) {
    let recommendedProduct = response.data.content[ 0 ];
    this.setRecommendedEdition();

    if (recommendedProduct) {
      this.recommendedProduct = recommendedProduct;
    }
    if (this.entitler) {
      if (this.entitler.createValues.length && this.entitler.deleteValues.length) {
        this.recommendationName = 'Assign/Unassign';
      } else if (this.entitler.createValues.length && !this.entitler.deleteValues.length) {
        this.recommendationName = 'Assign';
      } else if (!this.entitler.createValues.length && this.entitler.deleteValues.length) {
        this.recommendationName = 'Unassign';
      } else if (!this.entitler.createValues.length && !this.entitler.deleteValues.length) {
        const assignSchools = _.keys(this.entitler.schoolMapping.creates);
        const unAssignSchools = _.keys(this.entitler.schoolMapping.deletes);
        if (assignSchools.length && unAssignSchools.length) {
          this.recommendationName = 'Assign/Unassign';
        } else if (assignSchools.length && !unAssignSchools.length) {
          this.recommendationName = 'Assign';
        } else if (!assignSchools.length && unAssignSchools.length) {
          this.recommendationName = 'Unassign';
        }
      }
    }
  }

  tabLabel(tabName) {
    if (tabName === 'courses') {
      return 'Course';
    } else if(tabName === 'classes') {
      return 'Class';
    } else if(tabName === 'users') {
      return 'User';
    }
  }

  doesEntitlerHaveSelectedResources() {
    return !_.isEmpty(this.entitler && this.entitler.selectedResources);
  }

  // `doesEntitlerHaveSelectedResources()` above only guarantees
  // selectedResources is a non-empty *something* per lodash's _.isEmpty
  // (e.g. a non-empty plain object or string would also pass it), so
  // reading `selectedResources[0].id` directly is not fully safe on its
  // own. This defensively checks selectedResources is really an array with
  // a real first entry before reading `.id`, returning null otherwise
  // instead of throwing.
  getSelectedResourceId() {
    const selectedResources = this.entitler && this.entitler.selectedResources;
    if (!Array.isArray(selectedResources) || !selectedResources.length) {
      return null;
    }
    const firstResource = selectedResources[0];
    return (firstResource && firstResource.id) || null;
  }

  assignRecommendation() {
    let request = {
      // This now carries forward whatever resource is currently selected,
      // ASSUMING the recommended productAssignmentId (a different, sibling
      // productAssignmentId per api/controllers/productAssignments.js
      // `recommend()` - matched by title/purchasingAccountName, not by
      // resource) shares the same enterpriseResourceId pool as the
      // original. That is true in the common case but is NOT validated
      // anywhere: the backend assignProducts DAO persists whatever
      // enterpriseResourceId it's given without checking it belongs to the
      // recommended product's productAssignmentEnterpriseResources set. If
      // that assumption is ever wrong for some title/edition pair, this
      // will submit a mismatched (rather than null) enterpriseResourceId.
      // Treated as an acceptable low-risk improvement over always-null for
      // this ticket; if it becomes a problem, harden by re-fetching
      // /products/{recommendedProductId}/resources here instead (same
      // pattern as productsSelector.controller.js#onResourceRetreivalSuccess).
      //
      // getSelectedResourceId() is used instead of a direct
      // `selectedResources[0].id` read so this can't throw if
      // selectedResources ends up null/undefined/empty/non-array.
      enterpriseResourceId: this.getSelectedResourceId(),
      type: this.entitler.currentTab,
      assign: this.entitler.createValues,
      unassign: this.entitler.deleteValues,
      productAssignmentId: this.recommendedProduct.id,
      assignSchools: this.entitler.schoolMapping.creates,
      unassignSchools: this.entitler.schoolMapping.deletes,
      manageLicenses: this.entitler.manageLicenses
    };

    this.submitRecommendations(request).then(
      this.onSubmitRecommendationsSuccess.bind(this),
      this.onSubmitRecommendationsFailure.bind(this)
    );
  }

  submitRecommendations(request) {
    return this.entitlerService.updateProductsAssociations(request);
  }

  onSubmitRecommendationsSuccess() {
    let selectedProduct = angular.copy(this.recommendedProduct);
    this.entitler.selectedProducts.push(selectedProduct);
    this.toggleAssignability();
    this.entitler.isProductsAssignmentSuccessful = true;
  }

  onSubmitRecommendationsFailure() {
    this.recommendedAssociationFailed = false;
  }

  toggleAssignability() {
    delete this.recommendedProduct;
  }

  setRecommendedEdition() {
    this.recommendedEdition = this.selectedProductIsStudentEdition() ? 'TEACHER' : 'STUDENT';
  }

  selectedProductIsStudentEdition() {
    return (this.entitler && this.entitler.selectedProducts && this.entitler.selectedProducts.length && this.entitler.selectedProducts[0] && this.entitler.selectedProducts[0].edition === 'S');
  }

  getPrettyEdition(product) {
    let isTeacherEdition = product && product.edition ? product.edition === 'T' : this.selectedProductIsStudentEdition();
    let prettyEdition = isTeacherEdition ? 'TEACHER_EDITION' : 'STUDENT_EDITION';
    return prettyEdition;
  }

  resetEntitler() {
    let entitler = {
      selectedProducts: [],
      selectedResources: [],
      selectedSchools: [],
      selectedClasses: [],
      selectedCourses: [],
      allClasses: [],
      schoolList: [],
      isProductsAssignmentSuccessful: false,
      isResourcesAutoAssigned: false,
      schoolMappingUpdated: false
    };
    angular.copy(entitler, this.entitler);
  }

  almostResetEntitler() {
    let entitler = {
      selectedProducts: this.entitler.selectedProducts,
      selectedResources: this.entitler.selectedResources,
      selectedSchools: [],
      selectedClasses: [],
      selectedCourses: [],
      allClasses: [],
      schoolList: [],
      isProductsAssignmentSuccessful: false,
      isResourcesAutoAssigned: false,
      schoolMappingUpdated: false
    };
    angular.copy(entitler, this.entitler);
  }

  resetMessageDefaults() {
    this.entitler.isProductsAssignmentSuccessful = false;
  }
}

AssignmentConfirmationController.$inject = ['$state', 'entitlerService', 'statusIndicatorService'];

export
default AssignmentConfirmationController;



// WEBPACK FOOTER //
// ./app/components/assignmentConfirmation/assignmentConfirmation.controller.js